import React from 'react'
import { CircularProgress } from '@mui/material'

export function ImportLoader() {
    return (
        <div>
            <CircularProgress />
            <span>Reading file, please wait...</span>
        </div>
    )
}